// extracted by mini-css-extract-plugin
export var dropdownIcon = "_qn-6";
export var imgContainer = "_qn-3";
export var menuIcon = "_qn-5";
export var pillWrapper = "_qn-2";
export var pillsContainer = "_qn-1";
export var subscriptionCard = "_qn-0";
export var subscriptionLogo = "_qn-4";